<template>
    <div class="page-wrapper">
      <div class="logo-container">
        <img
          src="/static/images/logo.png"
          alt="Logo"
          width="250"
          height="60"
        >
      </div>
      <div class="card" :class="{ 'card--sent': requestSent }">
        <transition name="fade" mode="out-in">

          <div v-if="!requestSent" key="default" class="card-content">
            <div class="lock-icon">
              <svg viewBox="0 0 48 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="4" y="24" width="40" height="28" rx="6"
                  stroke="#2ECC71" stroke-width="3" fill="#2ECC71" fill-opacity="0.1"/>

                <path d="M10 24V16C10 8.268 16.268 2 24 2C31.732 2 38 8.268 38 16V24"
                  stroke="#2ECC71" stroke-width="3" stroke-linecap="round" fill="none"/>

                <circle cx="24" cy="37" r="4" fill="#2ECC71"/>
                <line x1="24" y1="41" x2="24" y2="46" stroke="#2ECC71" stroke-width="3" stroke-linecap="round"/>
              </svg>
            </div>

            <h1 class="title">
              Você ainda não tem acesso<br>ao PlaceMarket
            </h1>

            <p class="description">
              Para acessar o painel, é necessário solicitar a liberação com
              nosso time comercial.<br>
              Após a ativação, seu acesso ficará disponível automaticamente.
            </p>

            <button class="btn-primary" @click="handleRequest" :disabled="loading">
              <span v-if="!loading">SOLICITAR LIBERAÇÃO</span>
              <span v-else class="loader"></span>
            </button>

            <p class="helper-text">
              Entre em contato com nosso time comercial e garanta seu acesso ao painel.
            </p>

            <div class="divider"></div>

            <button class="btn-back" @click="goBack">
              ← Voltar para o login
            </button>
          </div>
        </transition>
      </div>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import api from '@/api'
  import Cookie from 'vue-cookie'

  export default {
    name: 'NoAccess',
    data () {
      return {
        loading: false,
        requestSent: false
      }
    },
    methods: {
      async handleRequest () {
        this.loading = true

        await new Promise(resolve => setTimeout(resolve, 1500))
        this.loading = false
        this.requestSent = true

        window.location.href = 'https://www.moovin.com.br/contato'
      },
      goBack () {
        Cookie.delete('token')
        Cookie.delete('merchant')
        api.redirectToLogarme()
      },
      ...mapActions('user', [
        'logout'
      ])
    },
    computed: {
      ...mapGetters('user', [
        'user'
      ])
    }
  }
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@400;600;700;800&display=swap');

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.page-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #EBEBEB;
  padding: 24px;
  width: 100%;
  font-family: 'Nunito', sans-serif;
}

.logo-container img {
  width: 250px;
  height: auto;
  display: block;
  margin: 0 auto 20px;
}

.card {
  background: #fff;
  border-radius: 16px;
  width: 100%;
  max-width: 580px;
  padding: 48px 56px 36px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  transition: box-shadow 0.3s ease;
}

.card:hover {
  box-shadow: 0 8px 32px rgba(0,0,0,0.11);
}

.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.lock-icon svg,

.title {
  font-size: 22px;
  font-weight: 800;
  color: #111;
  line-height: 1.35;
  margin-bottom: 18px;
}

.description {
  font-size: 13px;
  color: #666666;
  line-height: 1.7;
  margin-bottom: 32px;
  max-width: 420px;
}

.btn-primary {
  width: 100%;
  padding: 18px;
  background: #2ECC71;
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 800;
  letter-spacing: 1.5px;
  cursor: pointer;
  transition: background 0.2s ease, transform 0.1s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 58px;
  margin-bottom: 20px;
}

.btn-primary:hover:not(:disabled) {
  background: #27b863;
  transform: translateY(-1px);
}

.btn-primary:active:not(:disabled) {
  transform: translateY(0);
}

.btn-primary:disabled {
  cursor: not-allowed;
  opacity: 0.85;
}

.loader {
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255,255,255,0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
  display: inline-block;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

.helper-text {
  font-size: 13px;
  color: #999999;
  line-height: 1.6;
  max-width: 380px;
  margin-bottom: 28px;
}

.divider {
  width: 100%;
  height: 1px;
  background: #eee;
  margin-bottom: 24px;
}

.btn-back {
  background: none;
  border: none;
  color: #999999;
  font-size: 15px;
  font-family: 'Nunito', sans-serif;
  cursor: pointer;
  transition: color 0.2s ease;
  padding: 4px 8px;
}

.btn-back:hover {
  color: #2ECC71;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from {
  opacity: 0;
  transform: translateY(10px);
}

.fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

@media (max-width: 480px) {
  .card {
    padding: 36px 24px 28px;
  }

  .title {
    font-size: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// AccessError.vue?5356edf7